export enum EventType {
  AddCharacter,
  Move,
  ReceiveDamage,
  Die,
  TowerAttack,
  Heal,
  AddStatus,
  RemoveStatus,
  ResonanceStatus,
  KnockBack,
  AddTerrain,
  PushSlip,
  ProcessWeather,
  TowerLevelUp,
  TroopLevelUp,
}

export enum CharacterType {
  CellWay,
  GateSpawn,
  MainHouse,
  Tower,
  Troop,
}